module.exports = __webpack_public_path__ + "static/media/mickael-large.3e2e4eda.jpg";